import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import moment from "moment-timezone";
export default {
  name: "WineDiscountPricePostedModificationPopover",
  props: {
    modification: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    getUserInfos: function getUserInfos() {
      return "".concat(this.modification.lastModifiedByUser.name, " ").concat(this.modification.lastModifiedByUser.lastName);
    },
    returnLocalDateTime: function returnLocalDateTime() {
      return moment.utc(this.modification.lastModifiedAt).local().format("DD/MM/YYYY HH:mm");
    }
  }
};